import * as React from "react";
import TableViewIcon from "@mui/icons-material/TableView";
import { useHistory } from "react-router-dom";
import { ActionButton } from "components";

export interface SeeRelatedTablesButtonProps {
  productLineId?: string;
  propertyId?: string;
}

export const SeeRelatedTablesButton: React.FC<SeeRelatedTablesButtonProps> = ({
  productLineId,
  propertyId,
}) => {
  const history = useHistory();

  // Do the URL construction to show Tables view for tables containing the property
  const relatedTablesURL = React.useMemo(() => {
    if (productLineId && propertyId) {
      return `/products/${productLineId}/rules-tables?propertyIds=${encodeURIComponent(
        propertyId
      )}`;
    } else {
      return "";
    }
  }, [productLineId, propertyId]);

  const hasUrl = !!relatedTablesURL;

  // The action buttons main action
  const doAction = React.useCallback(() => {
    //Push the desired URL for the tables screen with tables containing
    //the property to the browser window.
    if (hasUrl) {
      history.push(relatedTablesURL);
    }
  }, [hasUrl, history, relatedTablesURL]);

  const handleButtonClick = React.useCallback<
    React.MouseEventHandler<HTMLButtonElement>
  >(
    (e) => {
      // Left-click only
      if (e.button !== 0) return;

      //prevent the normal click action
      e.preventDefault();

      //Do the action buttons action
      doAction();
    },
    [doAction]
  );

  return (
    <a
      href={hasUrl ? relatedTablesURL : undefined}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
    >
      <ActionButton
        tooltipText="See Related Tables"
        tooltipArrow
        tooltipPlacement="bottom"
        ariaLabel="See related tables"
        icon={TableViewIcon}
        iconOnly
        size="medium"
        color="primary"
        disabled={!hasUrl}
        onClick={handleButtonClick}
      />
    </a>
  );
};
